import store from '../store'

export default async (to, from, next) => {
    const user = store.getters['auth/user'];

    if (user.hasRoles(['admin', 'reception'])) {
        next();
    } else {
        next('/403');
    }
}